import type { CustomCsvImportCapabilities } from "../services/brokerIntegrationApi";
import type { CsvImportProfile } from "../types/customCsvImport";

const DEFAULT_TEMPLATES_ENDPOINT = "/broker/custom-csv/templates";

export function resolveCustomCsvTemplatesEndpoint(
  csvImport?: Pick<CustomCsvImportCapabilities, "templates_endpoint" | "profiles_endpoint"> | null
): string {
  return (
    csvImport?.templates_endpoint?.trim() ||
    csvImport?.profiles_endpoint?.trim() ||
    DEFAULT_TEMPLATES_ENDPOINT
  );
}

/** Normalize API row — accepts `template_slug` or legacy `profile_slug`. */
export function normalizeCsvImportTemplate(row: Record<string, unknown>): CsvImportProfile {
  const slug = String(row.template_slug ?? row.profile_slug ?? "").trim();
  return {
    ...(row as unknown as CsvImportProfile),
    profile_slug: slug,
  };
}

export function getCsvImportTemplateSlug(template: CsvImportProfile): string {
  return template.profile_slug;
}

export function parseCustomCsvTradeLabelParts(tradeLabel: string): {
  executingBroker: string;
  accountLabel: string;
} {
  const trimmed = tradeLabel.trim();
  const split = trimmed.match(/^(.+?)\s*[–-]\s*(.+)$/);
  if (split) {
    return {
      executingBroker: split[1].trim(),
      accountLabel: split[2].trim(),
    };
  }
  return { executingBroker: "", accountLabel: trimmed };
}
